if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

if (document.readyState !== 'loading') {
  initCode();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    initCode();
  });
}

function initCode() {
  const mainProductContainer = document.querySelector(".js-main-product");
  const productBottomSticky = document.querySelector(".js-product-bottom");
  //if (!mainProductContainer || !productBottomSticky) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > (mainProductContainer.offsetTop + mainProductContainer.offsetHeight)) {
      productBottomSticky.classList.add('--sticky');
    } else {
      productBottomSticky.classList.remove('--sticky');
    }
  });


  // Desc
  const desc = document.getElementsByClassName('js-product-container');
  const showMore = document.getElementsByClassName('js-product-more');
  const showLess = document.getElementsByClassName('js-product-less');
  if (showMore[0] && showLess[0]) {
    showMore[0].addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      desc[0].classList.add('--show');
    });
    showLess[0].addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      desc[0].classList.remove('--show');
    });
  }

  // Hide review if none
  const reviews = document.getElementsByClassName('jdgm-rev-widg__reviews');
  if (!reviews.length || (reviews.length && reviews[0].childNodes.length === 0)) {
    const sectionReview = document.querySelector('[id*="judgeme_section_review_widget"]');
    sectionReview.classList.add('--hiddenReview');
    const rateReview = document.querySelector('.jdgm-widget.jdgm-preview-badge').parentNode;
    rateReview.style.display = 'none';
  }
}